import { DismissablePromptKey } from '@ms/yammer-data/dist/state/types';

import { useDismissablePrompt } from './selectors';

type UseIsPromptDismissed = (promptKey: DismissablePromptKey) => boolean;
export const useIsPromptDismissed: UseIsPromptDismissed = (promptKey) => {
  const prompt = useDismissablePrompt(promptKey);

  return !!prompt?.isDismissed;
};
